<template>
  <v-card class="chatViolaion" flat>
    <AdminToolbar
      :searchTypes="searchTypes" 
      :search_condition.sync="search_condition"
      :sortTypes="sortTypes"
      :sort.sync="sort"
      :tabs="tabs"
      :tab.sync="tab"
      @searching="searching"
    ></AdminToolbar>
    <v-btn fixed right bottom icon x-large class="indigo" style="z-index: 1" to="/admin/chat/newViolation">
      <v-icon color="white">fa-plus</v-icon>
    </v-btn>

    <div class="table">
      <v-row class="table-header" no-gutters>
        <v-col>暱稱</v-col>
        <v-col>內容</v-col>
        <v-col>建立時間</v-col>
        <v-col style="min-width: 200px; max-width: 200px"></v-col>
      </v-row>

      <div class="table-body">
        <template v-for="record in violations">
          <v-row class="table-content" no-gutters :key="record.id">
            <v-col></v-col>
            <v-col>
              <template v-for="(word, i) in record.text.split(record.keyword)">
                {{ word }}
                <span :key="i" class="red--text font-weight-bold" v-if="i != record.text.split(record.keyword).length - 1">
                  {{ record.keyword }}
                </span>
              </template>
            </v-col>
            <v-col>{{ record.created_at | formatDate }}</v-col>
            <v-col style="min-width: 200px; max-width: 200px">
              <v-btn icon color="error" @click="deleteViolation(record)">
                <v-icon>fa-trash-alt</v-icon>
              </v-btn>
              <v-btn icon color="success" @click="commitViolation(record)">
                <v-icon>fa-check</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </div>
    </div>
  </v-card>
</template>

<script>
import AdminToolbar from '@/components/admin/AdminToolbar'
export default {
  components: { AdminToolbar },
  data() {
    return {
      busy: false,
      page: 1,
      searchTypes: [
        { text: '主播ID', value: 'seller_id' },
        { text: '會員ID', value: 'member_id' },
      ],
      sortTypes: [],
      sort: '',
      tabs: [
        {text: '待審核', value: 'pending'},
        {text: '已違規', value: 'commit'},
        {text: '已刪除', value: 'deleted'},
      ],
      tab: 0,
      search_condition: [],
      violations: []
    }
  },
  created() {
    this.getViolations()
  },
  methods: {
    searching() {
      console.log('search')
      this.violations = []
      this.getViolations()
    },
    getViolations() {
      let paramsObj = {}
      this.search_condition.forEach(condition => {
        paramsObj[condition.value] = condition.keyword
      })
      if(this.tabs[this.tab].value == 'pending') {
        paramsObj['commit'] = 0
        paramsObj['deleted'] = 0
      }
      else {
        paramsObj[this.tabs[this.tab].value] = 1
      }
      let searchParams = new URLSearchParams(paramsObj)
      this.axios(`/admin/violation?${searchParams.toString()}`).then(response => {
        this.violations = response.data.reverse().map(record => {
          let text = record.reason.match(/原文: (.*)\n/)
          let keyword = record.reason.match(/違反關鍵字: (.*)/)
          record.text = text ? text[1] : ''
          record.keyword = keyword ? keyword[1] : ''
          return record
        })
      })
    },
    commitViolation(record) {
      this.$root.$emit('loading', true)
      this.axios.put(`/admin/violation/${record.id}/commit`).then(response => {

      }).catch(() => {
        this.$root.$emit('alert', 'error', '更新失敗')
      }).finally(() => {
        this.$root.$emit('loading', false)
      })
    },
    deleteViolation(record) {
      this.$root.$emit('loading', true)
      this.axios.delete(`/admin/violation/${record.id}`).then(response => {
        this.violations.splice(this.violations.findIndex(violation => violation.id == record.id ), 1)
      }).catch(() => {
        this.$root.$emit('alert', 'error', '更新失敗')
      }).finally(() => {
        this.$root.$emit('loading', false)
      })
    }
  }
}
</script>

<style lang="scss">
.chatViolaion {
  
}
</style>